export const
    cloud_card_six = require('./cloud-transparent6.png'),
    crooked_parachute = require('./icon-supplydrop-orange-light.svg'),
    modal_cloud_dark = require('./modal_cloud_dark.svg'),
    parachute = require('./icon-supplydrop-orange.svg')